import React from 'react';
import { forwardRef } from '../../system/forwardRef.es.js';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
import { Slider as Slider$1, Rail, ActiveRangeRail, Draggable, Handle } from './styled.es.js';
import { useSlider } from './useSlider.es.js';
import { useDrag } from './useDrag.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DragHandle = (_a) => {
  var _b = _a, {
    position,
    radius,
    onChange,
    onChangeEnd,
    minPosition,
    maxPosition,
    defaultPosition,
    isDisabled
  } = _b, props = __objRest(_b, [
    "position",
    "radius",
    "onChange",
    "onChangeEnd",
    "minPosition",
    "maxPosition",
    "defaultPosition",
    "isDisabled"
  ]);
  const { currentPosition, isDragging, handleMouseDown, handleTouchStart } = useDrag({
    position,
    minPosition,
    maxPosition,
    defaultPosition,
    onChange,
    onChangeEnd,
    isDisabled
  });
  return /* @__PURE__ */ React.createElement(Draggable, __spreadValues({
    onMouseDown: handleMouseDown,
    onTouchStart: handleTouchStart,
    radius,
    position: currentPosition,
    isDragging
  }, props), /* @__PURE__ */ React.createElement(Handle, {
    radius,
    isDisabled
  }));
};
const Slider = forwardRef((props, ref) => {
  const _a = props, {
    children,
    width = 300,
    onChange,
    onChangeEnd,
    min,
    max,
    hasRange = false,
    handleRadius = 10,
    isDisabled = false,
    defaultValue,
    value,
    as
  } = _a, rest = __objRest(_a, [
    "children",
    "width",
    "onChange",
    "onChangeEnd",
    "min",
    "max",
    "hasRange",
    "handleRadius",
    "isDisabled",
    "defaultValue",
    "value",
    "as"
  ]);
  const {
    positions,
    minPosition,
    maxPosition,
    updateMinFromPosition,
    updateMaxFromPosition,
    onMinChangeEnd,
    onMaxChangeEnd
  } = useSlider(props);
  return /* @__PURE__ */ React.createElement(Slider$1, __spreadValues({
    min,
    max,
    width,
    ref,
    forwardedAs: as
  }, rest), /* @__PURE__ */ React.createElement(Box, {
    display: "flex",
    width: "100%"
  }, /* @__PURE__ */ React.createElement(Rail, {
    isDisabled
  }), hasRange && /* @__PURE__ */ React.createElement(ActiveRangeRail, {
    handleRadius,
    range: { min: positions.min, max: positions.max },
    isDisabled
  }), /* @__PURE__ */ React.createElement(DragHandle, {
    position: positions.min,
    radius: handleRadius,
    onChange: updateMinFromPosition,
    onChangeEnd: onMinChangeEnd,
    minPosition,
    maxPosition: hasRange ? positions.max : maxPosition,
    defaultPosition: minPosition,
    isDisabled
  }), hasRange && /* @__PURE__ */ React.createElement(DragHandle, {
    position: positions.max,
    radius: handleRadius,
    onChange: updateMaxFromPosition,
    onChangeEnd: onMaxChangeEnd,
    minPosition: positions.min,
    maxPosition,
    defaultPosition: maxPosition,
    isDisabled
  })));
});
Slider.displayName = "Slider";

export { Slider };
//# sourceMappingURL=Slider.es.js.map
